import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import JornadaTrabalhoProvider from "./PipeLineContext";
import PesquisarJornadaTrabalho from "./Events/PesquisarPipeLine";
import FormularioJornadaTrabalho from "./Events/FormularioPipeLine";

const Index = () => {
  let match = useRouteMatch();
  return (
    <JornadaTrabalhoProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarJornadaTrabalho}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioJornadaTrabalho}
          />
        </Switch>
      </div>
    </JornadaTrabalhoProvider>
  );
};

export default Index;
